import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DialogType, MediDialogComponent } from '../medi-dialog/medi-dialog.component';
import { Einstellungen } from '../model/einstellungen';
import { OroService } from '../oroservice';

const MaxNumber: number = 999999;

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false
})

export class SettingsComponent implements OnInit {
    kundensettings: Einstellungen;
    isLoading = true;

    public adressrechercheIndex: number = 3;
    public rechtlichIndex: number = 3;
    public bonitaetspruefungIndex: number = 3;
    public erbrechercheIndex: number = 3;
    public auslandIndex: number = 3;

    private OldData: string;


    constructor(public oroservice: OroService,
        private _router: Router,
        private cdref: ChangeDetectorRef,
        public dialog: MatDialog,
        private fb: FormBuilder) {
    }

    public mainForm!: FormGroup;


    public checkMahnstufen() {
        const mahnstufen = this.mainForm.get("mahnstufen").value;

        if (mahnstufen === 1) {
            this.kundensettings.SendM1 = true;
            this.kundensettings.SendM2 = false;
            this.kundensettings.SendM3 = false;
            this.mainForm.get("m1").setValidators([Validators.required, Validators.min(30), Validators.max(45)]);
        }
        if (mahnstufen === 2) {
            this.kundensettings.SendM1 = true;
            this.kundensettings.SendM2 = true;
            this.kundensettings.SendM3 = false;
            this.mainForm.get("m1").setValidators([Validators.required, Validators.min(7), Validators.max(45)]);
        }
        if (mahnstufen === 3) {
            this.kundensettings.SendM1 = true;
            this.kundensettings.SendM2 = true;
            this.kundensettings.SendM3 = true;
            this.mainForm.get("m1").setValidators([Validators.required, Validators.min(7), Validators.max(45)]);
        }
        this.mainForm.get('m1').setValue(30);
        this.mainForm.get('m2').setValue(15);
        this.mainForm.get('m3').setValue(15);
    }

    public isErrorMahnung() : boolean {
        return this.mainForm.get('m1').hasError('min') || this.mainForm.get('m1').hasError('max')
            || this.mainForm.get('m2').hasError('min') || this.mainForm.get('m2').hasError('max')
            || this.mainForm.get('m3').hasError('min') || this.mainForm.get('m3').hasError('max');

    }

    public isErrorWert1Wert2(param: string) : boolean {
        const w1 = this.mainForm.get(param + '1');
        const w2 = this.mainForm.get(param + '2');

        return !w1?.hasError('required') && !w2?.hasError('required') && (w1?.hasError('max') || w2?.hasError('min'));
    }

    public isErrorWertMax(param: string) : boolean {
        const wert = this.mainForm.get(param);

        return wert?.hasError('max');
    }

    public getMahnungError() : string {
        return this.mainForm?.get("mahnstufen").value === 1 ? "Einstellungen.ErrorWertMahungAlt" : "Einstellungen.ErrorWertMahung";
    }

    public initForm() {
        if (this.kundensettings) {
            const m1Min = this.kundensettings.Mahnstufe === 1 ? 30 : 7;
            this.mainForm = this.fb.group({
                auftragsbestätigung: [this.kundensettings.Auftragsbestaetigung],
                vorrechlichesInkasso: [this.kundensettings.NurVorrechtInkasso],
                verjaehrung: [this.kundensettings.Verjaehrung],
                schnittstellenverarbeitung: [this.kundensettings.Schnittstellenverarbeitung],
                standardGrund: [this.kundensettings.Forderungsgrund],
                mahnstufen: [this.kundensettings.Mahnstufe],
                m1: [this.kundensettings.M1, [Validators.required, Validators.min(m1Min), Validators.max(45)]],
                m2: [this.kundensettings.M2, [Validators.required, Validators.min(7), Validators.max(45)]],
                m3: [this.kundensettings.M3, [Validators.required, Validators.min(7), Validators.max(45)]],
                adressrechercheWert1: [this.kundensettings.AdressRech1, [Validators.required, Validators.max(this.kundensettings.AdressRech2)]],
                adressrechercheWert2: [this.kundensettings.AdressRech2, [Validators.required, Validators.min(this.kundensettings.AdressRech1), Validators.max(999999)]],
                rechtlichWert1: [this.kundensettings.BetreibPruefStufe1, [Validators.required, Validators.max(this.kundensettings.BetreibPruefStufe2)]],
                rechtlichWert2: [this.kundensettings.BetreibPruefStufe2, [Validators.required, Validators.min(this.kundensettings.BetreibPruefStufe1), Validators.max(999999)]],
                bonitaetspruefungWert: [this.kundensettings.BoniPruefStufe, [Validators.required, Validators.max(999999)]],
                betreibRueckfrage: [this.kundensettings.BetreibRueckfrage],
                verlustscheinverwaltung: [this.kundensettings.Verlustscheinverwaltung],
                erbrechercheWert1: [this.kundensettings.ErbrecherchepuefungStufe1, [Validators.required, Validators.max(this.kundensettings.ErbrecherchepuefungStufe2)]],
                erbrechercheWert2: [this.kundensettings.ErbrecherchepuefungStufe2, [Validators.required, Validators.min(this.kundensettings.ErbrecherchepuefungStufe1), Validators.max(999999)]],
                auslandWert1: [this.kundensettings.AuslandsinkassoStufe1, [Validators.required, Validators.max(this.kundensettings.AuslandsinkassoStufe2)]],
                auslandWert2: [this.kundensettings.AuslandsinkassoStufe2, [Validators.required, Validators.min(this.kundensettings.AuslandsinkassoStufe1), Validators.max(999999)]],

                adressrechercheIndex: [this.adressrechercheIndex],
                rechtlichIndex: [this.rechtlichIndex],
                bonitaetspruefungIndex: [this.bonitaetspruefungIndex],
                erbrechercheIndex: [this.erbrechercheIndex],
                auslandIndex: [this.auslandIndex]
              });

              this.OldData = JSON.stringify(this.mainForm.value);
        }
    }

    public formToSettings() {
        this.kundensettings.Auftragsbestaetigung = this.mainForm.get("auftragsbestätigung").value;
        this.kundensettings.NurVorrechtInkasso = this.mainForm.get("vorrechlichesInkasso").value;
        this.kundensettings.Forderungsgrund = this.mainForm.get("standardGrund").value;
        this.kundensettings.Verjaehrung = this.mainForm.get("verjaehrung").value;
        this.kundensettings.Mahnstufe = this.mainForm.get("mahnstufen").value;
        this.kundensettings.M1 = this.mainForm.get("m1").value;
        this.kundensettings.M2 = this.mainForm.get("m2").value;
        this.kundensettings.M3 = this.mainForm.get("m3").value;
        this.kundensettings.AdressRech1 = this.mainForm.get("adressrechercheWert1").value;
        this.kundensettings.AdressRech2 = this.mainForm.get("adressrechercheWert2").value;
        this.kundensettings.BetreibPruefStufe1 = this.mainForm.get("rechtlichWert1").value;
        this.kundensettings.BetreibPruefStufe2 = this.mainForm.get("rechtlichWert2").value;
        this.kundensettings.BoniPruefStufe = this.mainForm.get("bonitaetspruefungWert").value;
        this.kundensettings.BetreibRueckfrage = this.mainForm.get("betreibRueckfrage").value;
        this.kundensettings.Verlustscheinverwaltung = this.mainForm.get("verlustscheinverwaltung").value;
        this.kundensettings.ErbrecherchepuefungStufe1 = this.mainForm.get("erbrechercheWert1").value;
        this.kundensettings.ErbrecherchepuefungStufe2 = this.mainForm.get("erbrechercheWert2").value;
        this.kundensettings.AuslandsinkassoStufe1 = this.mainForm.get("auslandWert1").value;
        this.kundensettings.AuslandsinkassoStufe2 = this.mainForm.get("auslandWert2").value;
    }

    public changeIndex(n: number, wert1: string, wert2: string, standard1: number = 100, standard2: number = 100): void {
        switch (n) {
            case 0:
                this.mainForm.get(wert1).setValue(0);
                this.mainForm.get(wert2).setValue(0);
                break;

            case 1:
                this.mainForm.get(wert1).setValue(0);
                this.mainForm.get(wert2).setValue(MaxNumber);
                break;

            case 2:
                this.mainForm.get(wert1).setValue(MaxNumber);
                this.mainForm.get(wert2).setValue(MaxNumber);
                break;

            case 3:
                this.mainForm.get(wert1).setValue(standard1);
                this.mainForm.get(wert2).setValue(standard2);
                break;
        }

        this.mainForm.get(wert1).setValidators([Validators.required, Validators.max(this.mainForm.get(wert2).value)]);
        this.mainForm.get(wert2).setValidators([Validators.required, Validators.min(this.mainForm.get(wert1).value), Validators.max(999999)]);

        this.mainForm.get(wert1).updateValueAndValidity();
        this.mainForm.get(wert2).updateValueAndValidity();
    }

    public onChangeAdressrecherche(checkIndex: boolean): void {
        const index = checkIndex ? this.mainForm.get("adressrechercheIndex").value : -1;
        this.changeIndex(index, "adressrechercheWert1", "adressrechercheWert2", 100, 100);
    }

    public onChangeRechtlich(checkIndex: boolean): void {
        const index = checkIndex ? this.mainForm.get("rechtlichIndex").value : -1;
        this.changeIndex(index, "rechtlichWert1", "rechtlichWert2", 100, 100);
    }

    public onChangeErbrecherche(checkIndex: boolean): void {
        const index = checkIndex ? this.mainForm.get("erbrechercheIndex").value : -1;
        this.changeIndex(index, "erbrechercheWert1", "erbrechercheWert2", 1000, 1000);
    }

    public onChangeAusland(checkIndex: boolean): void {
        const index = checkIndex ? this.mainForm.get("auslandIndex").value : -1;
        this.changeIndex(index, "auslandWert1", "auslandWert2", 1000, 1000);
    }

    public onChangeBonitaetspruefung(): void {
        switch (this.mainForm.get("bonitaetspruefungIndex").value) {
            case 0:
                this.mainForm.get("bonitaetspruefungWert").setValue(MaxNumber);
                break;

            case 1:
                this.mainForm.get("bonitaetspruefungWert").setValue(0);;
                break;

            case 3:
                this.mainForm.get("bonitaetspruefungWert").setValue(500);;
                break;
        }
    }

    public showAdressrecherche(): boolean {
        return this.mainForm.get("adressrechercheIndex").value === 3;
    }

    public showRechtlich(): boolean {
        return this.mainForm.get("rechtlichIndex").value === 3;
    }

    public showErbrecherche(): boolean {
        return this.mainForm.get("erbrechercheIndex").value === 3;
    }

    public showAusland(): boolean {
        return this.mainForm.get("auslandIndex").value === 3;
    }



    ngOnInit() {
        this.oroservice.getKundenInfo().then(
            () => {
                if (!this.oroservice.kundeninfo.IsMaster) {
                    this._router.navigate(['Startseite']);
                } else {
                    this.refresh();
                }
            }
        );
    }

    public onSubmit() {
        this.formToSettings();
        this.oroservice.setSettings(this.kundensettings);
        this.OldData = JSON.stringify(this.mainForm.value);
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        const NewData = JSON.stringify(this.mainForm.value);
        return (!this.OldData || this.OldData.localeCompare(NewData) === 0);
	}


    private initData() : void {
        if (!this.kundensettings) {
            return;
        }

        // Adressrecherche
        if (this.kundensettings.AdressRech1 === 0 && this.kundensettings.AdressRech2 === 0) {
            this.adressrechercheIndex = 0;
        } else if (this.kundensettings.AdressRech1 === 0 && this.kundensettings.AdressRech2 === MaxNumber) {
            this.adressrechercheIndex = 1;
        } else if (this.kundensettings.AdressRech1 === MaxNumber && this.kundensettings.AdressRech2 === MaxNumber) {
            this.adressrechercheIndex = 2;
        } else {
            this.adressrechercheIndex = 3;
        }

        // Betreibung
        if (this.kundensettings.BetreibPruefStufe1 === 0 && this.kundensettings.BetreibPruefStufe2 === 0) {
            this.rechtlichIndex = 0;
        } else if (this.kundensettings.BetreibPruefStufe1 === 0 && this.kundensettings.BetreibPruefStufe2 === MaxNumber) {
            this.rechtlichIndex = 1;
        } else if (this.kundensettings.BetreibPruefStufe1 === MaxNumber && this.kundensettings.BetreibPruefStufe2 === MaxNumber) {
            this.rechtlichIndex = 2;
        } else {
            this.rechtlichIndex = 3;
        }

        // Bonitätsprüfung
        if (this.kundensettings.BoniPruefStufe === MaxNumber) {
            this.bonitaetspruefungIndex = 0;
        } else if (this.kundensettings.BoniPruefStufe === 0) {
            this.bonitaetspruefungIndex = 1;
        } else {
            this.bonitaetspruefungIndex = 3;
        }

        // Erbrecherche
        if (this.kundensettings.ErbrecherchepuefungStufe1 === 0 && this.kundensettings.ErbrecherchepuefungStufe2 === 0) {
            this.erbrechercheIndex = 0;
        } else if (this.kundensettings.ErbrecherchepuefungStufe1 === 0 && this.kundensettings.ErbrecherchepuefungStufe2 === MaxNumber) {
            this.erbrechercheIndex = 1;
        } else if (this.kundensettings.ErbrecherchepuefungStufe1 === MaxNumber && this.kundensettings.ErbrecherchepuefungStufe2 === MaxNumber) {
            this.erbrechercheIndex = 2;
        } else {
            this.erbrechercheIndex = 3;
        }

        // Auslandinkasso
        if (this.kundensettings.AuslandsinkassoStufe1 === 0 && this.kundensettings.AuslandsinkassoStufe2 === 0) {
            this.auslandIndex = 0;
        } else if (this.kundensettings.AuslandsinkassoStufe1 === 0 && this.kundensettings.AuslandsinkassoStufe2 === MaxNumber) {
            this.auslandIndex = 1;
        } else if (this.kundensettings.AuslandsinkassoStufe1 === MaxNumber && this.kundensettings.AuslandsinkassoStufe2 === MaxNumber) {
            this.auslandIndex = 2;
        } else {
            this.auslandIndex = 3;
        }
    }

    refresh() {
        this.oroservice.getSettings().then((object) => {
            this.kundensettings = object;
            this.isLoading = false;
            this.kundensettings.Mahnstufe = this.getMahnstufe();
            this.initData();
            this.initForm();
        });
    }

    getMahnstufe() {
        let i = 0;
        if (this.kundensettings.SendM1) {
            i++;
        }
        if (this.kundensettings.SendM2) {
            i++;
        }
        if (this.kundensettings.SendM3) {
            i++;
        }
        return i;
    }

    openDialogVSVerwaltungAktivierenOderDeaktivieren() {
        if (this.mainForm.get('verlustscheinverwaltung').value) {
            this.openDialog("620px", "Einstellungen.Verlustscheinverwaltung",
                            "Einstellungen.Verlustscheinverwaltungfrage", "Einstellungen.Aktivieren",
                            "Abbrechen", DialogType.Question).subscribe(result => {
                    this.mainForm.get('verlustscheinverwaltung').setValue(result);
            });
        } else {
            this.openDialog("630px", "Einstellungen.Verlustscheinverwaltung",
                            "Einstellungen.VerlustscheinverwaltungsfrageDeaktivieren", "Einstellungen.Deaktivieren",
                            "Abbrechen", DialogType.Question).subscribe(result => {
                        this.mainForm.get('verlustscheinverwaltung').setValue(!result);
                            });
        }
    }

    openDialog(paramWidth: string, paramTitle: string, paramContent: string, paramYes: string, paramNo: string, paramType: DialogType = DialogType.None): Observable<boolean> {
        const dialogRef = this.dialog.open(MediDialogComponent, {
            width: paramWidth,
            data: { title: paramTitle, content: paramContent, yes: paramYes, no: paramNo, type: paramType }
        });

        return dialogRef.afterClosed();
    }
}
